/**
 * @file fraud.js
 * @description 欺诈通知模块路由配置
 * @module router/config/fraud
 * @Business 欺诈相关业务的路由定义，包括欺诈通知查询等功能
 *
 * @BusinessChanges 本次路由变更梳理 / Route Changes Summary:
 * 1. 新增欺诈通知详情页面路由 / Added fraud notification details page route
 * 2. 支持通过serviceId参数访问详情页面 / Support accessing details page with serviceId parameter
 * 3. 路由路径设计遵循RESTful规范 / Route path design follows RESTful conventions
 */

export default [
  {
    path: 'risk/fraud-notification',
    name: 'Fraud Notification',
    component: () => import('@/views/risk/fraud-notification/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:fraud-notification:list',
      name: 'message.fraudNotification.title',
    },
  },
  {
    // 欺诈通知详情页面路由配置 / Fraud notification details page route configuration
    path: 'risk/fraud-notification/details/:serviceId',
    name: 'Fraud Notification Details',
    component: () => import('@/views/risk/fraud-notification/details/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:fraud-notification:details', // 详情页面权限码 / Details page permission code
      name: 'message.fraudNotificationDetails.pageTitle', // 页面标题多语言键 / Page title i18n key
      hideInMenu: true, // 在菜单中隐藏该路由 / Hide this route in menu
    },
  },
];
